// application
import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';
import { SubModelRequest } from '@/main/models/request';

export abstract class ISubModelApi {
  abstract getVehicleSubModel(
    request: SubModelRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
